import hasDom from 'has-dom';

/**
 * Polyfill for creating CustomEvents on IE9/10/11 if native implementation is missing.
 */
function CustomEvent(event, params) {
  params = params || {
    bubbles: false,
    cancelable: false,
    detail: undefined
  };
  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
  return evt;
}
if (hasDom() && typeof window.CustomEvent !== 'function') {
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}
export default (function (type, detail) {
  if (detail === void 0) {
    detail = {};
  }
  const analyticsEvent = new CustomEvent(`analytics:${type}`, {
    detail
  });
  if (hasDom()) {
    // dispatch event on window
    window.dispatchEvent(analyticsEvent);

    // dispatch event on document
    window.document.dispatchEvent(analyticsEvent);

    // we want to keep history of events
    // so any events that listen to the custom event doesn't miss anything
    window.analyticsEventHistory = window.analyticsEventHistory || [];
    window.analyticsEventHistory.push({
      type,
      detail
    });

    // keep the size of entries small
    if (window.analyticsEventHistory.length > 50) {
      window.analyticsEventHistory.shift();
    }
  }
});